import { FC } from 'react';
import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { useNotificationContext } from '../../shared/hook/useNotificationContext';

const Notification: FC = () => {
    const { notification, clearNotification } = useNotificationContext();

    if (!notification) {
        return null;
    }

    return (
        <Snackbar
            open={!!notification}
            onClose={clearNotification}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ mt: 2 }}
        >
            <Alert
                onClose={clearNotification}
                severity={notification.type}
                variant="filled"
                sx={{
                    minWidth: '300px',
                    boxShadow: 4,
                }}
            >
                <AlertTitle sx={{ fontWeight: 600 }}>
                    {notification.type.charAt(0).toUpperCase() + notification.type.slice(1)}
                </AlertTitle>
                {notification.message}
            </Alert>
        </Snackbar>
    );
};

export default Notification;
